import { api } from './client';

export interface ReportBugBody {
  url: string;
  type: 'bug' | 'rozvoj';
  description: string;
}

export function reportBug(body: ReportBugBody): Promise<{ bugId: number; taskId: number }> {
  return api.post<{ bugId: number; taskId: number }>('/api/v1/bugs/report', body);
}
